import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @function evaluate - evaluate docRipperQueryTitleBehavior
 *
 * Retrieve the cached matches (if any) as well as the selected options
 * Format a string indicating selections made or found options
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const importField = content.importField,
    importFormType = content.importFormType;
  const _Object$values = Object.values(importFormType),
    _Object$values2 = _slicedToArray(_Object$values, 1),
    formTypeTitle = _Object$values2[0].title;
  const _Object$values3 = Object.values(importField),
    _Object$values4 = _slicedToArray(_Object$values3, 1),
    fieldTitle = _Object$values4[0].title;
  const potentialMatches = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'docRipper/potentialMatches'
  });
  if (potentialMatches === undefined) {
    return "Retrieve '".concat(fieldTitle, "' for all '").concat(formTypeTitle, "' assets");
  }
  return "Found ".concat(Object.keys(potentialMatches).length, " '").concat(fieldTitle, "' values for all '").concat(formTypeTitle, "' assets");
};
export default {
  evaluate
};